export const getNowAsUTCString = (): string => {
  return new Date().toISOString();
};
